import { createStylesContext } from "@chakra-ui/react"

export const [
  AttachmentStylesProvider,
  useAttachmentStyles,
] = createStylesContext("Attachment")
